import { useState } from "react";

function LoginForm({ onLogin, errorMessage, isSubmitting = false }) {
  const [credentials, setCredentials] = useState({ id: "", password: "" });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onLogin(credentials);
  };

  return (
    <div className="login-card">
      <h1 className="page-title">筋トレ管理ログイン</h1>
      <form className="login-form" onSubmit={handleSubmit}>
        <label className="form-label">
          ID
          <input
            className="form-input"
            name="id"
            value={credentials.id}
            onChange={handleChange}
            autoComplete="username"
            required
            disabled={isSubmitting}
          />
        </label>
        <label className="form-label">
          パスワード
          <input
            className="form-input"
            name="password"
            type="password"
            value={credentials.password}
            onChange={handleChange}
            autoComplete="current-password"
            required
            disabled={isSubmitting}
          />
        </label>
        {errorMessage ? <p className="form-error">{errorMessage}</p> : null}
        <button
          className="primary-button"
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? "ログイン中..." : "ログイン"}
        </button>
      </form>
    </div>
  );
}

export default LoginForm;
